import { render, staticRenderFns } from "./Kontakt.vue?vue&type=template&id=13ffa6a8&scoped=true"
import script from "./Kontakt.vue?vue&type=script&lang=js"
export * from "./Kontakt.vue?vue&type=script&lang=js"
import style0 from "./Kontakt.vue?vue&type=style&index=0&id=13ffa6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ffa6a8",
  null
  
)

export default component.exports